import { Button, Modal } from "antd";
import React from "react";

import TextInfo from "../../../../../components/common/TextInfo/TextInfo";
import {
  AuthorizationList,
  CanAccess,
} from "../../../../../components/template/authorization/Authorization";

const AddRefundDialog = ({
  visible,
  handleCancel,
  handleSave,
  actionButtonText,
  title,
  onInputChange,
  onSelectChange,
  errors,
  data,
  bankOptions,
  onImageChange,
  handleUploadImage,
  transferProofImg,
  approvalProofImg,
  handleSavePermissions = true,
}) => {
  const handleChange =
    (type, field = "") =>
    (event) => {
      if (type === "number") {
        onInputChange(field, event.value);
      } else if (type === "input") {
        const { name, value } = event.target;
        onInputChange(name, value);
      }
    };

  return (
    <Modal
      className="modal-form"
      title={title}
      visible={visible}
      onCancel={handleCancel}
      width={"30%"}
      centered
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          className="btn-modal btn-default"
        >
          Kembali
        </Button>,
        <CanAccess
          role={handleSavePermissions}
          yes={
            <Button
              key="submit"
              type="primary"
              onClick={handleSave}
              className="btn-modal"
            >
              {actionButtonText}
            </Button>
          }
        />,
      ]}
    >
      <div className="modal-form-content" style={{ gap: "0px" }}>
        <TextInfo
          title="Kode Gadai"
          value={data.gadaiCode}
          type={"input"}
          id={"gadaiCode"}
          handleChange={handleChange("input")}
          error={errors?.gadaiCode}
          placeholder={"Masukkan Kode Gadai"}
          isForm
        />
        <TextInfo
          title="Reward"
          value={data.reward}
          isInputNumber
          type={"input"}
          id={"reward"}
          handleChange={handleChange("number", "reward")}
          error={errors?.reward}
          placeholder={"Masukkan Jumlah Reward"}
          isForm
        />
        <TextInfo
          title="Sisa Uang Lelang"
          value={data.remainingMoney}
          isInputNumber
          type={"input"}
          id={"remainingMoney"}
          handleChange={handleChange("number", "remainingMoney")}
          error={errors?.remainingMoney}
          placeholder={"Masukkan Jumlah Sisa Lelang"}
          isForm
        />
        <TextInfo
          title="Keterangan"
          value={data.description}
          isTextArea
          type={"input"}
          id={"description"}
          handleChange={handleChange("input")}
          error={errors?.description}
          placeholder={"Masukkan Keterangan"}
          isForm
        />
        <TextInfo
          title="Bank"
          value={data.bankName}
          type={"select"}
          id={"bankName"}
          handleChange={onSelectChange}
          error={errors?.bankName}
          placeholder={"Pilih Bank"}
          isSearchable
          selectOptions={bankOptions}
          isForm
        />
        <TextInfo
          title="No. Rekening"
          value={data.accountNumber}
          type={"input"}
          id={"accountNumber"}
          handleChange={handleChange("input")}
          error={errors?.accountNumber}
          placeholder={"Masukkan Nomor Rekening"}
          isForm
        />
        <TextInfo
          title="Nama Rekening"
          value={data.accountName}
          type={"input"}
          id={"accountName"}
          handleChange={handleChange("input")}
          error={errors?.accountName}
          placeholder={"Masukkan Nama Rekening"}
          isForm
        />
        <TextInfo
          title="Bukti Transfer"
          type={"upload"}
          id={"transferProof"}
          helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
          handleImageChange={onImageChange("transferProof")}
          customRequest={handleUploadImage("transferProof")}
          fileList={transferProofImg}
          error={errors?.transferProof}
          isForm
        />
        <TextInfo
          title="Bukti Persetujuan"
          type={"upload"}
          id={"transferProof"}
          helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
          handleImageChange={onImageChange("approvalProof")}
          customRequest={handleUploadImage("approvalProof")}
          fileList={approvalProofImg}
          error={errors?.approvalProof}
          isForm
        />
      </div>
    </Modal>
  );
};

export default AddRefundDialog;
